import React, { useState } from "react";
import MobileLayout from "../components/layout/MobileLayout";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast, Toaster } from "sonner";

export default function MPinPage() {
  const [oldP, setOldP] = useState("");
  const [newP, setNewP] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (newP.length !== 4) return toast.error("New MPIN must be 4 digits");
    if (newP !== confirm) return toast.error("MPINs do not match");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { old_password: oldP, new_password: newP });
      toast.success("Password updated");
      setOldP(""); setNewP(""); setConfirm("");
    } catch (e) { toast.error(formatApiError(e)); } finally { setLoading(false); }
  };

  return (
    <MobileLayout>
      <Toaster richColors position="top-center" />
      <h1 className="font-display font-bold text-2xl tracking-tight text-gold-static mb-3">Change Password</h1>
      <div
        className="rounded-2xl p-4 space-y-3 shadow-xl backdrop-blur-sm"
        style={{
          background: "linear-gradient(180deg, rgba(10,24,51,0.65) 0%, rgba(6,14,40,0.9) 100%)",
          border: "1px solid rgba(34,211,238,0.25)",
        }}
      >
        <div>
          <Label className="text-[11px] uppercase tracking-widest text-cyan-200/80 font-black">Current MPIN</Label>
          <Input data-testid="mpin-old" type="password" inputMode="numeric" maxLength={4} value={oldP} onChange={(e)=>setOldP(e.target.value.replace(/\D/g,""))}
            className="mt-1.5 h-11 tracking-widest bg-black/40 border-cyan-400/30 text-white placeholder:text-slate-500 focus-visible:ring-cyan-400" />
        </div>
        <div>
          <Label className="text-[11px] uppercase tracking-widest text-cyan-200/80 font-black">New MPIN</Label>
          <Input data-testid="mpin-new" type="password" inputMode="numeric" maxLength={4} value={newP} onChange={(e)=>setNewP(e.target.value.replace(/\D/g,""))}
            className="mt-1.5 h-11 tracking-widest bg-black/40 border-cyan-400/30 text-white placeholder:text-slate-500 focus-visible:ring-cyan-400" />
        </div>
        <div>
          <Label className="text-[11px] uppercase tracking-widest text-cyan-200/80 font-black">Confirm New MPIN</Label>
          <Input data-testid="mpin-confirm" type="password" inputMode="numeric" maxLength={4} value={confirm} onChange={(e)=>setConfirm(e.target.value.replace(/\D/g,""))}
            className="mt-1.5 h-11 tracking-widest bg-black/40 border-cyan-400/30 text-white placeholder:text-slate-500 focus-visible:ring-cyan-400" />
        </div>
        <Button data-testid="mpin-submit" onClick={submit} disabled={loading}
          className="w-full h-11 font-black text-white tracking-wide"
          style={{ background: "linear-gradient(135deg,#22d3ee 0%,#2563eb 100%)" }}>
          {loading ? "Saving…" : "Update MPIN"}
        </Button>
      </div>
    </MobileLayout>
  );
}
